class viewTemplate {
    constructor($injector) {
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');

        this.key = 'view-template';
        this.title = this.translate.instant('templates.workflows.list.view-template.title');
        this.level = 'row';
    }

    action(payload, store) {
        return this.state.go('app.templates.details', {id: payload.row.id, store: store});
    }

}

angular
    .module('festzelt-os.modules.templates')
    .factory('viewTemplate', [
        '$injector',
        $injector => new viewTemplate($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/templates/workflows/list/view-template.js